import { css } from 'emotion';

export const container = css`
  padding: 20px 0;
  width: 100%;
`;

export const startIcon = css`
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 10px;
  }
`;

export const header = css`
  h2 {
    display: flex;
    justify-content: space-between;
    line-height: unset;

    & > span:nth-of-type(2) {
      display: flex;
    }
  }
  && {
    padding: 0px 20px;
  }
`;

export const dialogContent = css`
  && {
    padding: 0;
    overflow: unset;
  }
`;

// Overriding MUI styling
export const buttonGroup = css`
  && {
    margin: 0;
    padding: 0 20px;
    :empty {
      display: none;
    }
  }
`;

export const divider = css`
  && {
    padding: 10px 20px;
  }
`;
